import { useCallback , useEffect } from "react"

export const useOnClickOutsideCards = (handleUnselect: () => void) => {

  const handleAssetsMousedownOutside = useCallback((event: MouseEvent) => {
    if (event.target instanceof HTMLElement) {
      const target = event.target
      
      const notNeedUnselect = target.closest('.js-board-card') 
        || target.closest('.js-asset-card') 
        || target.closest('.js-asset-card-dropdown') 
        || target.closest('.ant-modal-content') 
        || target.closest('.js-page-toolbar-top')
        || target.closest('.js-page-toolbar-top-dropdown')
        || target.closest('.js-board-card-dropdown')

      if (!notNeedUnselect) {
        handleUnselect()
      }
    }
  }, [handleUnselect])

  useEffect(() => {
    document.addEventListener('mousedown', handleAssetsMousedownOutside)

    return () => {
      document.removeEventListener('mousedown', handleAssetsMousedownOutside)
    }
  }, [])
}